"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbConstants = exports.authConstants = exports.db = exports.auth = void 0;
var app_1 = __importDefault(require("firebase/app"));
require("firebase/auth");
require("firebase/database");
var FirebaseConfig_1 = __importDefault(require("./FirebaseConfig"));
if (!app_1.default.apps.length) {
    app_1.default.initializeApp(FirebaseConfig_1.default());
}
exports.auth = app_1.default.auth();
exports.db = app_1.default.database();
exports.authConstants = app_1.default.auth;
exports.dbConstants = app_1.default.database;
//# sourceMappingURL=firebase.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/firebase.js
// module id = 49
// module chunks = 8